
import { computed, defineComponent } from 'vue'
// Components
import ProductsFilter from '@/components/ProductsFilter.vue'
// Constants
import { PRODUCTS_VIEW_LIST } from '@/constants'
// Router
import { useRouter, type Router, useRoute } from 'vue2-helpers/vue-router'
import { Route } from "vue-router";

export default defineComponent({
	name: 'SwitcherWithFilter',

	components: { ProductsFilter },

	setup() {
    // Router
    const router: Router = useRouter()
    const route: Route = useRoute()

    // Computed
    const query = computed(() => route.query)
    const productsView = computed(() => query.value.view)

    // Methods

    const changeProductsView = (): void => {
      const currentView = productsView.value
      const currentViewIndex = PRODUCTS_VIEW_LIST.findIndex(
          listItem => listItem === currentView
      )

      const newView =
          currentViewIndex === 0
              ? PRODUCTS_VIEW_LIST[1]
              : PRODUCTS_VIEW_LIST[0]

      router.replace({ query: { ...query.value, view: newView } })
    }

		return {
			PRODUCTS_VIEW_LIST,
      productsView,
			changeProductsView
		}
	}
})
